import { useMutation } from "react-query";
import api from "../../client";
import { Checklist, UpdateChecklistPayload } from "../../types/checklist";

const patchData = async (
  id: string | undefined,
  payload: UpdateChecklistPayload,
): Promise<Checklist> => {
  const { data } = await api.patch(`/checklists/${id}`, payload);

  return data;
};

export const useUpdateChecklist = (id: string | undefined) => {
  return useMutation((payload: UpdateChecklistPayload) => {
    return patchData(id, payload);
  });
};
